/* eslint-disable @typescript-eslint/no-unnecessary-condition */

import { uniq } from "es-toolkit";
import type { Product } from "../client";
import type { KeyFact } from "./KeyFacts";

export function toType(product: Product) {
  switch (product.type) {
    case "DIGITAL_MODEL": {
      return "model";
    }

    case "DIGITAL":
    case "DIGITAL_BOOK": {
      return "book";
    }
  }
}

export function getKeyFacts(product: Product) {
  const items: KeyFact[] = [];

  if (
    product.type === "DIGITAL" ||
    product.type === "DIGITAL_BOOK" ||
    product.type === "DIGITAL_MODEL"
  ) {
    items.push({ type: "IMMEDIATE_DOWNLOAD" });
  }

  if (product.unlocks?.length) {
    items.push({
      type: "UNLOCKS",
      features: product.unlocks.map((u) => u.feature),
    });
  }

  if (product.isEarlyAccess) {
    items.push({ type: "EARLY_ACCESS" });
  }

  return items;
}

export function mergeKeyFacts(factLists: KeyFact[][]): KeyFact[] {
  const flat = factLists.flat();
  const merged: KeyFact[] = [];

  if (flat.some((f) => f.type === "IMMEDIATE_DOWNLOAD")) {
    merged.push({ type: "IMMEDIATE_DOWNLOAD" });
  }

  const features = uniq(
    flat.flatMap((f) => (f.type === "UNLOCKS" ? f.features : [])),
  );

  if (features.length) {
    merged.push({ type: "UNLOCKS", features });
  }

  if (flat.some((f) => f.type === "EARLY_ACCESS")) {
    merged.push({ type: "EARLY_ACCESS" });
  }

  return merged;
}
